/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const PayLater: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 19V9L19 9V11.5859L11.5859 19H5ZM14.4141 19H19V14.4141L14.4141 19ZM21 19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19Z'
      fill='currentColor'
    />
  </React.Fragment>
)
